var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abstretch ofhidden bg-dark"},[_c('div',{ref:"viewerRoot",staticClass:"w-100 h-100 abstretch bg-dark"})])}
var staticRenderFns = []

export { render, staticRenderFns }